import React from 'react';
import { useRouter } from 'next/router';
import { TechnicalTable } from '@product/TechnicalTable/TechnicalTable';
import { useTechnicalDrawingsDataQuery } from './useTechnicalDrawingsDataQuery';
import { getLocale } from '@libs/constants';
import { QueryStatusHandler } from '@common/QueryStatusHandler/QueryStatusHandler';

type TechnicalDrawingsDataTableProps = {
  technicalAttributes?: string[];
};
export const TechnicalDrawingsDataTable: React.FC<TechnicalDrawingsDataTableProps> = ({ technicalAttributes = [] }) => {
  const router = useRouter();
  const locale = getLocale(router);

  const { data, status } = useTechnicalDrawingsDataQuery(locale, technicalAttributes);

  return (
    <QueryStatusHandler status={status}>
      <TechnicalTable data={data || []} />
    </QueryStatusHandler>
  );
};
